import * as _ from 'lodash';
import { pxToRem } from '../../utils';
var headerStyles = {
    root: function (_a) {
        var p = _a.props, v = _a.variables;
        return ({
            display: 'block',
            color: _.get(v.colors, p.color, v.color),
            fontSize: pxToRem(22),
            fontWeight: 400,
        });
    },
};
export default headerStyles;
